import { defineStore } from 'pinia';

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    isExpanded: true
  }),
  actions: {
    toggleSidebar() {
      this.isExpanded = !this.isExpanded;
    }
  }
});
